import React from 'react'

export const useAsyncCallback = <T extends Array<unknown>>(
  cb: (...args: T) => Promise<void>
): [(...args: T) => Promise<void>, boolean] => {
  const [pending, setPending] = React.useState(false)

  const run = async (...args: T) => {
    try {
      setPending(true)
      await cb(...args)
    } finally {
      setPending(false)
    }
  }

  return [run, pending]
}
